import React from 'react';

const sizeMap = {
  xSmall: {
    symbol: 'text-xs',
    integer: 'text-base',
    decimal: 'text-base',
  },
  small: {
    symbol: 'text-sm font-semibold',
    integer: 'text-xl font-semibold',
    decimal: 'text-sm font-semibold',
  },
  medium: {
    symbol: 'text-base font-semibold',
    integer: 'text-2xl font-semibold',
    decimal: 'text-lg font-semibold',
  },
  normal: {
    symbol: 'text-sm font-semibold',
    integer: 'text-3xl font-semibold',
    decimal: 'text-sm font-semibold',
  },
  large: {
    symbol: 'text-lg font-semibold',
    integer: 'text-4xl font-semibold',
    decimal: 'text-xl font-semibold',
  },
};

const CurrencyText = ({ value, size = 'medium', color = 'text-blueHighlight', className = '', byPeriod = '' }) => {
  const number = Number(value);
  const [integerPartRaw, decimalPart] = number.toFixed(2).split('.');
  const integerPart = Number(integerPartRaw).toLocaleString('pt-BR');
  const classes = sizeMap[size] || sizeMap.medium;

  return (
    <div className={`flex ${color} ${className}`}>
      <div className="flex items-baseline">
        <span className={`${classes.symbol} mr-1`}>R$</span>
        <span className={classes.integer}>{integerPart}</span>
        <span className={classes.decimal}>,{decimalPart}</span>
        {byPeriod && <span className={`ml-2 ${classes.decimal}`}>/{byPeriod}</span>}
      </div>
    </div>
  );
};

export default CurrencyText;
